import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=6cc3d6b6"
import script from "./Workflows.vue?vue&type=script&lang=js"
export * from "./Workflows.vue?vue&type=script&lang=js"
import style0 from "./Workflows.vue?vue&type=style&index=0&id=6cc3d6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports